import React, { useState } from "react";
import { legalDisclaimerApi, SocialLogin } from "../../../api/user";
import { useGoogleLogin } from "@react-oauth/google";
import "./Login.css";
import googleImg from "../../../images/Google.png";
import { sendEvent } from "../../../utils/event";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LegalPopupModal from "../../../components/Modals/legalDisclaimer";

const GoogleButton = () => {
  const [loader, setLoader] = useState(false);
  const [showPopup, setShowPopUp] = useState(false);
  const [checked, setChecked] = useState(false);

  const responseMessage = (response) => {
    console.log(response, "resposefirst");
    setLoader(true);
    // console.log("Google responseL", response);
    getTokenInfo(response?.access_token);
    localStorage.setItem("aaaa", response?.access_token);
  };

  const handleCheckboxChange1 = () => {
    setChecked(!checked);
  };

  const handleClose = () => {
    navigate("/profile");
    localStorage.setItem("checkDisclaimer", false);
    return setShowPopUp(false);
  };

  const handleLegalPopup = async () => {
    if (!checked) {
      toast.error("Please accept our legal policies.");
      return;
    }
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    try {
      const res = await legalDisclaimerApi(checked);
      if (res?.data?.status === 200) {
        setShowPopUp(false);
        if (userInfo?.user_name) {
          navigate("/profile");
        } else {
          navigate("/edit-profile");
        }
        localStorage.setItem("checkDisclaimer", false);
      }
    } catch (err) {}
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => responseMessage(codeResponse),
  });

  const getTokenInfo = async (token) => {
    try {
      const response = await fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${encodeURIComponent(
          token
        )}`
      );
      console.log(response, "resposefirst2");

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      console.log("GOOGLEEEEEEEEE", data);
      const socialData = {
        social_id: data?.sub,
        email: data?.email,
        first_name: data?.given_name,
        last_name: data?.family_name,
        type: 2,
        social_type: 2,
      };

      // console.log("socialData", socialData);
      localStorage.setItem("userEmail", socialData.email);
      LoginUser(socialData);
    } catch (error) {
      console.error("Error fetching token info:", error.message);
    }
  };

  const navigate = useNavigate();

  const LoginUser = (data) => {
    SocialLogin(data)
      .then((response) => {
        console.log("RESPONSE: ", response);
        if (response?.data?.status === 200) {
          if (response?.data?.data?.disclaimer === false) {
            setShowPopUp(true);
            localStorage.setItem("checkDisclaimer", true);
          } else {
            navigate("/profile");
          }
          localStorage.setItem("user_id", response.data.data.id);
          const token = response?.data?.data?.access_token;
          localStorage.setItem(
            "isVerified",
            response?.data?.data?.is_otp_verified
          );
          localStorage.setItem("google_login", "1");
          localStorage.setItem("img", response?.data?.data?.image);
          localStorage.setItem(
            "userInfo",
            JSON.stringify(response?.data?.data)
          );
          localStorage.setItem("accessToken", JSON.stringify(token));
          setLoader(false);
        } else {
          setLoader(false);
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        console.log(error, "error");
        toast.error(error?.response?.data?.message);
      });
  };

  return (
    <>
      <div className="googleLoginButton" style={{ width: "100%" }}>
        <button
          onClick={() => {
            login();
            sendEvent("Googlee"); // Trigger the event on successful login
          }}
          className="mt-1 secondary-button text-black items-center !justify-center flex h-11 border border-gray-300"
        >
          {loader && <Loader />}
          {
            <img
              src={googleImg}
              className=" w-7 inline-block mx-1"
              alt="Google-logo"
            />
          }
          <span className="">Continue With Google</span>
        </button>
      </div>
      <LegalPopupModal
        isOpen={showPopup}
        handleLegalPopup={handleLegalPopup}
        checked={checked}
        handleClose={handleClose}
        handleCheckboxChange1={handleCheckboxChange1}
      />
    </>
  );
};

export default GoogleButton;
